import styled from 'styled-components'
import Toolbar from '@material-ui/core/Toolbar'

export default styled(Toolbar)`
  padding-right: 24px; // keep right padding when drawer closed
`
